/** Label for institution select/autocomplete options. */
export function getInstitutionSelectLabel(institution) {
  if (!institution?.name) return "";

  const parts = [institution.name];
  if (institution.organization_type?.name) {
    parts.push(institution.organization_type.name);
  }
  if (institution.city) {
    parts.push(institution.city);
  }
  return parts.join(" • ");
}

/** Institution pictogram for relation chips, asides, and autocompletes. */
export function getInstitutionIconUrl(institution, getMediaUrl) {
  if (!institution || typeof getMediaUrl !== "function") return null;
  const source = institution.icon || institution.logo;
  if (!source) return null;
  return getMediaUrl(source) || null;
}

/** Drop duplicate ids while preserving order (API/cache safety). */
export function dedupeInstitutionsById(institutions = []) {
  const seen = new Set();
  return institutions.filter((institution) => {
    const id = institution?.id;
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}
